import { FC } from 'react';
import { State } from 'redux/initialState';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { HoldingClass, Partner, Transaction } from 'types';

import { formatCurrencyDecimals, formatNumber } from 'utils/formats';

type SharesTransferOperationTableRowProps = {
  index: number;
  transactionsPair: Transaction[];
};

const SharesTransferOperationTableRow: FC<
  SharesTransferOperationTableRowProps
> = ({ index, transactionsPair }) => {
  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const [transactionBuyer, transactionSeller] = transactionsPair;

  const {
    partner: partnerBuyer,
    shareFrom,
    shareTo,
    shareClass,
    sharePremium = 0,
    sharePrice,
  } = transactionBuyer;

  const { partner: partnerSeller } = transactionSeller;

  const partnerSellerId = (partnerSeller as Partner)?._id || '';
  const partnerSellerName = (partnerSeller as Partner)?.name || '';
  const partnerBuyerId = (partnerBuyer as Partner)?._id || '';
  const partnerBuyerName = (partnerBuyer as Partner)?.name || '';
  const sharesCount = (shareTo || 0) - (shareFrom || 0) + 1;
  const className = (shareClass as HoldingClass)?.name || '';
  const total = sharesCount * (sharePrice || 0);

  return (
    <>
      <td
        className="text-left vertical-align-middle pl-2 pl-md-2"
        key={`buyer-name-${index}`}
      >
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerBuyerId}`}
        >
          {partnerBuyerName}
        </Link>
      </td>

      <td
        className="text-left vertical-align-middle pl-2 pl-md-2"
        key={`seller-name-${index}`}
      >
        <Link
          className="text-primary"
          to={`/detalle-socio/${actualSociety?._id}/${partnerSellerId}`}
        >
          {partnerSellerName}
        </Link>
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`shares-count-${index}`}
      >
        {formatNumber(sharesCount)}
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`share-from-${index}`}
      >
        {formatNumber(shareFrom || 0)}
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`share-to-${index}`}
      >
        {formatNumber(shareTo || 0)}
      </td>

      <td
        className="text-center vertical-align-middle"
        key={`class-name-${index}`}
      >
        {className}
      </td>

      <td
        className="text-right vertical-align-middle"
        key={`shares-price-${index}`}
      >
        {formatCurrencyDecimals(sharePrice || 0)}
      </td>

      {/* <td
        className="text-right vertical-align-middle"
        key={`shares-premium-${index}`}
      >
        {formatCurrencyDecimals(sharePremium || 0)}
      </td> */}

      <td className="text-right vertical-align-middle" key={`total-${index}`}>
        {formatCurrencyDecimals(total || 0)}
      </td>
    </>
  );
};
export default SharesTransferOperationTableRow;
